import React from "react";
import TabHeader from "../TabHeader";
import AccountForm from "./AccountForm/AccountForm";
import FeedbackForm from "./FeedbackForm/FeedbackForm";
import DangerButton from "../../../../../Components/DangerButton/DangerButton";
import CancelSubscriptionModal from "../../../../../Components/CancelSubscriptionModal/CancelSubscriptionModal";
import { withRouter } from "react-router-dom";
import call from "../../../../../API/API";
import "./AccountContent.css";

class AccountContent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showSubscriptionModal: false,
    };

    this.handleDangerButtonClick = this.handleDangerButtonClick.bind(this);
    this.handleModalOnClose = this.handleModalOnClose.bind(this);
    this.handleOnModalAccept = this.handleOnModalAccept.bind(this);
  }

  handleDangerButtonClick() {
    this.setState({
      showSubscriptionModal: true,
    });
  }

  handleModalOnClose() {
    this.setState({
      showSubscriptionModal: false,
    });
  }

  handleOnModalAccept(e) {
    call.payments
      .cancelSubscription()
      .then((result) => {
        if (result.success) {
          localStorage.clear();
          this.props.history.push("/");
        } else {
          this.props.showErrorBox("Error", result.results);
        }
      })
      .catch((err) => {
        this.props.history.push("/error", { error: err.message });
      });
  }

  render() {
    return (
      <main className="account-tab">
        <TabHeader
          tabHeaderTitle="Account"
          tabHeaderText="Change your account information"
        />
        <AccountForm
          showSuccessBox={this.props.showSuccessBox}
          showErrorBox={this.props.showErrorBox}
          handleNameUpdate={this.props.handleNameUpdate}
          handleLastNameUpdate={this.props.handleLastNameUpdate}
        />
        <FeedbackForm
          showSuccessBox={this.props.showSuccessBox}
          showErrorBox={this.props.showErrorBox}
        />
        <div className="cancel-subscription-container">
          <DangerButton
            dangerButtonText="Cancel subscription"
            handleDangerButtonOnClick={this.handleDangerButtonClick}
          />
        </div>

        {this.state.showSubscriptionModal ? (
          <CancelSubscriptionModal
            handleModalOnClose={this.handleModalOnClose}
            handleModalOnCancel={this.handleModalOnClose}
            handleOnModalAccept={this.handleOnModalAccept}
          />
        ) : null}
      </main>
    );
  }
}

export default withRouter(AccountContent);
